import classes from "./Placeholder.module.css";

export const Placeholder = () => {
  return <div className={classes.root} />;
};
